import { Clock, Edit3, Calculator, CheckCircle2, Banknote, Gift, TrendingDown, PhoneCall, AlertTriangle, FileText } from "lucide-react";

export const MONTH_NAMES_EN = [
  "January","February","March","April","May","June",
  "July","August","September","October","November","December",
];

export const statusConfig: Record<string, { color: string; icon: typeof Clock }> = {
  Draft: { color: "bg-gray-100 text-gray-600 border-gray-200", icon: Edit3 },
  Calculated: { color: "bg-blue-100 text-blue-600 border-blue-200", icon: Calculator },
  Approved: { color: "bg-emerald-100 text-emerald-600 border-emerald-200", icon: CheckCircle2 },
  Paid: { color: "bg-purple-100 text-purple-600 border-purple-200", icon: Banknote },
};

export const PIE_COLORS = ["#3b82f6", "#10b981", "#f59e0b", "#8b5cf6", "#ec4899", "#06b6d4"];

export const ADJ_TYPES = [
  { value: "bonus", labelKey: "payroll.adjustmentTypes.bonus", icon: Gift, color: "text-emerald-600" },
  { value: "deduction", labelKey: "payroll.adjustmentTypes.deduction", icon: TrendingDown, color: "text-red-600" },
  { value: "on_call", labelKey: "payroll.adjustmentTypes.onCall", icon: PhoneCall, color: "text-blue-600" },
  { value: "admin_prohibition", labelKey: "payroll.adjustmentTypes.adminProhibition", icon: AlertTriangle, color: "text-orange-600" },
  { value: "other", labelKey: "payroll.adjustmentTypes.other", icon: FileText, color: "text-gray-600" },
];
